import React, { Component, Fragment } from "react";
import { Row, Card,Button, CardBody, FormGroup, Input,
    DropdownItem,
	CustomInput, Badge,
    DropdownMenu } from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import { NavLink } from "react-router-dom";
import DataTablePagination from "../../../components/DatatablePagination";
import ItemDropdown from "../../../components/customer/ItemDropdown";
import AddEquipmentModal from "../../../containers/equipments/AddEquipmentModal";
import EditEquipmentModal from "../../../containers/equipments/EditEquipmentModal";
import ReactTable from "react-table";
import swal from 'sweetalert';
import {REST_API_END_POINT,dataEncryptKey,JQUERY_MODULE} from "../../../constants/defaultValues";
import axios from 'axios';
import SimpleCrypto from "simple-crypto-js";

var dataCrypto = new SimpleCrypto(dataEncryptKey);

export default class Equipments extends Component {
	
	constructor(props) {
		super(props);
		this.toggleSelectAll = this.toggleSelectAll.bind(this); //bind the function if it invoked to another component
		this.dataListRender = this.dataListRender.bind(this);
		
		this.state = {
		  equipment_id:0,	 
		  equipment_dependencies: [],
		  modalOpenAdd: false,
		  modalOpenEdit: false,
		  search: '',
		};
		this.deleteItem = this.deleteItem.bind(this);
	}
	
	toggleModalAdd = () => {
		this.setState({
		  modalOpenAdd: !this.state.modalOpenAdd
		});
	};
	
	toggleModalEdit = (e,equipment_id=0) => {
		this.setState({
			equipment_id: parseInt(equipment_id),
			modalOpenEdit: !this.state.modalOpenEdit,
		});
	};
	
	toggleSelectAll() {
        let newSelected = [];
        if (this.state.selectAll === 0) {
            this.state.equipments.forEach(x => {
                newSelected.push(x.equipment_id);
            });
        }
		this.setState({
            selectedIds: newSelected,
            selectAll: this.state.selectAll === 0 ? 1 : 0
        });
    }
	
	componentDidMount(){
	   this.dataListRender();
	}
	
   	deleteItem = (e,selectedIds,status)  => {
		var msg="";
		var success_msg="";
		var failure_msg="";
		var msg_word="equipment";
		
		if(selectedIds.length>1){
			msg_word="equipments";
		}
		
        if(status===1){
            msg="Activate the "+msg_word+" ?";
            success_msg="The "+msg_word+" has been activated.";
            failure_msg="Failed to activate "+msg_word;
        }else if(status===2){
            msg="Delete the "+msg_word+" ?";
            success_msg="The "+msg_word+" has been deleted.";
            failure_msg="Failed to delete "+msg_word;
        }else{
            msg="Deactivate the "+msg_word+" ?";
            success_msg="The "+msg_word+" has been deactivated.";
            failure_msg="Failed to deactivate "+msg_word;
        }
        swal({
          title: "Are you sure?",
          text: msg,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
		.then((willDelete) => {
			if (willDelete) {
				document.getElementById("delete-equipments").disabled=true;
			
				if(selectedIds.length){
					var user_id = localStorage.getItem('user_id');
					var facility_id = localStorage.getItem('facility_id');
					facility_id =  dataCrypto.decrypt(facility_id);
					var formData = new FormData();
					formData.append('equipment_ids',JSON.stringify(selectedIds));
					formData.append('status',status);
					formData.append('user_id',user_id);
					formData.append('facility_id',facility_id);
					
					axios.post(REST_API_END_POINT+'processor/delete-equipments',formData).then((res)=>{
						var data = res.data;
					
						document.getElementById("delete-equipments").disabled=false;
						
						var api_message=document.getElementById("api_message");
						if(data.status==1){
							api_message.innerHTML="<div class=\"rounded alert alert-success alert-dismissible fade show\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button><span>"+success_msg+"</span></div>";
						}else{
							api_message.innerHTML="<div class=\"rounded alert alert-danger alert-dismissible fade show\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button><span>"+failure_msg+"</span></div>";   
						}
						
						window.setTimeout(function() {
							JQUERY_MODULE.$(".alert").fadeTo(500, 0).slideUp(500, function(){
								JQUERY_MODULE.$(this).remove(); 
							});
						}, 5000);
						this.dataListRender();
						
					}).catch(e =>{
						console.log("Addition failed , Error ", e);
						document.getElementById("delete-equipments").disabled=false;
					});
				}
			}else{
				swal("Your operation is canceled!");
			}
		});
	} 
    
	activeItem=(e,equipment_id)=>{		
	    let selectedIds = this.state.selectedIds;		
	    let selectAll = this.state.selectAll;		
		if(e.target.checked){
			selectedIds.push(equipment_id);
			
		}else{
		  var x=selectedIds.indexOf(equipment_id);
		  if(x>=0){
				selectedIds.splice(x,1);
		  }
		}
		if(selectedIds.length!=0 && selectedIds.length==this.state.equipments.length){
			selectAll=1;
		}else{
			selectAll=0;
		}
		this.setState({selectedIds,selectAll});
	}
	
	dataListRender() {
		var facility_id = localStorage.getItem('facility_id');
		facility_id =  dataCrypto.decrypt(facility_id);
        var formData = new FormData();
        formData.append('facility_id',facility_id);
		
		axios.post(REST_API_END_POINT+'processor/get-all-equipments',formData).then((res)=>{
			var data = res.data;
		
			if(data.equipments){
				var equipment_dependencies = data.equipment_dependencies;
				equipment_dependencies = equipment_dependencies.map(row=>{
					row.label=row.name;
					row.value=row.id;
					row.key=row.id;
					return row;
				})
				this.setState({
					equipments: data.equipments,
					equipment_dependencies,
					selectAll:0,
					selectedIds:[]
				});
			}else{
				this.setState({
					equipments: [],
					selectAll:0,
					selectedIds:[]
				});
			}
        }).catch(e =>{
			console.log("Addition failed , Error ", e);
		});
	}
	
	render() {
		let data = this.state.equipments;
		if (this.state.search) {
			data = data.filter(row => {
				return row.equipment_name.toLowerCase().includes(this.state.search) || row.equipment_type_name.toLowerCase().includes(this.state.search) || row.created_on.toLowerCase().includes(this.state.search)
			})
		}
		
	const dataTableColumns = [		
		{
			Header: <CustomInput type="checkbox" id="select_all" onChange={this.toggleSelectAll} checked={this.state.selectAll===1} />,
			accessor: "equipment_id",
			width:50,
			sortable: false,
			Cell: ( rowInfo )=> {
				return ( <FormGroup>
					<CustomInput type="checkbox" id={"equipment_"+rowInfo.original.equipment_id} onChange={event =>this.activeItem(event,rowInfo.original.equipment_id) } checked={this.state.selectedIds.includes(rowInfo.original.equipment_id)} />
					</FormGroup> );
			}
		},
		{
			Header: "Name",
			accessor: "equipment_name",
			Cell: props => <p className="list-item-heading">{props.value}</p>
		},
		{
			Header: "Type",
			accessor: "equipment_type_name",
			Cell: props => <p className="text-muted">{props.value}</p>
		},
		{
			Header: "Created On",
			accessor: "created_on",
			Cell: props => <p className="text-muted">{props.value}</p>
		},	  
		{
			Header: "Status",
			accessor: "status",
			Cell: props => {
						if(props.value==0){ 
							return <span className="btn" style={{background:'#cfcfcf', color:'#000'}} >IDLE</span>; 
						} else if(props.value==1){ 
							return <span className="btn" style={{background:'#f2d505', color:'#000'}} >LOADING</span>; 
						} else if(props.value==2){ 
							return <span className="btn" style={{background:'#007eff', color:'#fff'}} >RUNNING</span>; 
						} else if(props.value==3){ 
							return <span className="btn" style={{background:'#ff1a1a', color:'#fff'}} >PAUSED</span>; 
						} else if(props.value==4){ 
							return <span className="btn" style={{background:'#00a80e', color:'#fff'}} >RUN COMPLETE</span>; 
						} else {
							return <span className="btn" style={{background:'#000', color:'#fff'}} >OUT OF SERVICE</span>; 
						}
					}
		},
		{
			Header: "Options",
			accessor: "equipment_id",
			width:70,
			sortable: false,
			Cell: props => <Button color="primary" size="xs" className="mb-2"  onClick={(e)=>this.toggleModalEdit(e,props.value)} >Edit</Button>
		},
	];
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.equipments" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>
		
		<Card className="p-4">
			<Row>
				<Colxx xxs="12">
					<div id="api_message"></div>
				</Colxx>
				<Colxx xxs="12">		
					<div className="float-sm-right">
						{" "}<Button																		 
							  color="primary"
							  size="sm"
							  className=""
							  onClick={this.toggleModalAdd}
							>
							  Add New 							  
						</Button>{" "}<Button
								id="delete-equipments"
								color="primary"
								size="sm"
								className=""
								onClick={event =>this.deleteItem(event,this.state.selectedIds,2)}							
							>
								<IntlMessages id="pages.delete" />
						</Button>
					</div>
				</Colxx>			
			</Row>
			<Row>			  
				<Colxx xxs="12">
					<div className="float-sm-right">
						{" "}
					</div>
					 <div className="mb-4 dropdown-edit">
						
						<FormGroup row>
							<Colxx lg="6">
								<Input
								  type="text"
								  name="table_search"
								  id="table_search"
								  placeholder="Search"
								  value={this.state.search}
								  onChange={e => this.setState({search: e.target.value.toLowerCase()})}
								/>
							</Colxx>
						</FormGroup>			
						<ReactTable
						  data={data}
						  columns={dataTableColumns}
						  defaultPageSize={10}
						  filterable={false}
						  showPageJump={false}
						  responsive
						  PaginationComponent={DataTablePagination}
						  showPageSizeOptions={true}
						  defaultSorted={[{id: "send_on",desc: true}]}
						/>
					</div>					
				</Colxx>
				
				<AddEquipmentModal
					modalOpen={this.state.modalOpenAdd}
					toggleModal={this.toggleModalAdd}
					dataListRender={this.dataListRender}
					equipment_dependencies={this.state.equipment_dependencies}
				/>
				<EditEquipmentModal
					modalOpen={this.state.modalOpenEdit}
					toggleModal={this.toggleModalEdit}
					dataListRender={this.dataListRender}
					equipment_dependencies={this.state.equipment_dependencies}			
					equipment_id={this.state.equipment_id}			
				/>	  
			</Row>
		</Card>
      </Fragment>
    );
  }
}
